import { getStorage } from "@-/dev.improve.haniverse.lib.storage";
import type { StudySessionCheckpoint } from "#study-session-clock";

/**
 * The study interval currently open, as of its last checkpoint. Written with each checkpoint and
 * removed when the interval closes, so finding it at the next launch means the process ended
 * mid-session and its `study_session_ended` was never sent.
 */
const OPEN_STUDY_SESSION_KEY = "analytics.openStudySession";

export function writeOpenStudySessionMarker(session: StudySessionCheckpoint): void {
  getStorage().set(OPEN_STUDY_SESSION_KEY, JSON.stringify(session));
}

export function clearOpenStudySessionMarker(): void {
  getStorage().remove(OPEN_STUDY_SESSION_KEY);
}

/** Returns and removes the marker; `null` when the last interval closed normally. */
export function takeOpenStudySessionMarker(): StudySessionCheckpoint | null {
  const raw = getStorage().getString(OPEN_STUDY_SESSION_KEY);
  if (raw === undefined) {
    return null;
  }
  clearOpenStudySessionMarker();
  try {
    const parsed: unknown = JSON.parse(raw);
    if (
      typeof parsed === "object" &&
      parsed !== null &&
      "id" in parsed &&
      "startedAt" in parsed &&
      "endedAt" in parsed &&
      typeof parsed.id === "string" &&
      typeof parsed.startedAt === "string" &&
      typeof parsed.endedAt === "string"
    ) {
      return { endedAt: parsed.endedAt, id: parsed.id, startedAt: parsed.startedAt };
    }
  } catch {
    // A corrupt marker carries no session worth reporting.
  }
  return null;
}
